export default __webpack_public_path__ + "static/media/loading_safari.1fcf17bc.svg";